import { Collapse } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { AttachmentIcon } from "~Components/icons/Attachment"
import { ExpandableListItemIcon } from "~Components/icons/ExpandableListItemIcon"
import { type AttachmentItem } from "~Shared/hooks/fileViewer.hooks"

interface AttachmentListProps {
    viewableAttachments: Array<AttachmentItem>
    onExpandChange: () => void
    setCurrentFileUrl: (url: string) => void
    setIsViewingAttachment: (isViewingAttachment: boolean) => void
}

export const AttachmentFileViewer = ({ viewableAttachments, onExpandChange, setCurrentFileUrl, setIsViewingAttachment }: AttachmentListProps) => {
    const { t } = useTranslation()

    if (viewableAttachments.length === 0) {
        return null
    }

    const ExpandIcon = ({ isActive }: { isActive?: boolean }) => <ExpandableListItemIcon className="block" expanded={isActive ?? false} />

    const handleViewAttachment = async (attachment: AttachmentItem) => {
        try {
            const data = await attachment.data
            const blob = new Blob([new Uint8Array(data)], { type: "application/pdf" })
            const url = URL.createObjectURL(blob)
            setCurrentFileUrl(url)
            setIsViewingAttachment(true)
        } catch (error) {
            console.error("Error viewing attachment:", error)
        }
    }

    return (
        <div className="flex file-viewer-collapse">
            <Collapse expandIcon={ExpandIcon} className="flex align-center text-sm font-bold text-finway-primary p-0" ghost bordered onChange={onExpandChange}>
                <Collapse.Panel
                    key="embedded-attachments"
                    header={`${t("label:embedded_attachments")} (${viewableAttachments.length})`}
                    showArrow={true}
                    className="text-finway-primary"
                >
                    {" "}
                    {viewableAttachments.map((attachment, index) => (
                        <div
                            key={index}
                            className="p-8 my-1 border flex items-center text-finway-primary justify-items-center border-gray-300 rounded-lg gap-8 transition-all duration-200 cursor-pointer"
                            onClick={() => handleViewAttachment(attachment)}
                        >
                            <AttachmentIcon />
                            <span className=" text-xs">{attachment.name}</span>
                        </div>
                    ))}
                </Collapse.Panel>
            </Collapse>
        </div>
    )
}
